import React from 'react'
import { Paper } from '@material-ui/core'

export const Menu = props => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
)



// WEBPACK FOOTER //
// ./src/components/SelectAutocomplete/components/Menu/index.js